import { makeStyles } from '@material-ui/styles'
import {
  CALLOUT_FOREGROUND,
  OUTLINED_INPUT_BORDER,
  OUTLINED_INPUT_BORDER_HOVER,
  OUTLINED_INPUT_BORDER_RADIUS,
  OUTLINED_INPUT_FOCUS_BORDER,
} from 'lib/form-field-styles'

const useStyles = makeStyles(theme => ({
  footerNote: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    textAlign: 'center',
    margin: 0,
  },
  policyField: {
    width: '100%',
    margin: 0,
    '& .MuiOutlinedInput-root': {
      borderRadius: OUTLINED_INPUT_BORDER_RADIUS,
      backgroundColor: theme.palette.common.white,
      '& fieldset': { borderColor: OUTLINED_INPUT_BORDER },
      '&:hover fieldset': { borderColor: OUTLINED_INPUT_BORDER_HOVER },
      '&.Mui-focused fieldset': {
        borderColor: OUTLINED_INPUT_FOCUS_BORDER,
        borderWidth: 1,
      },
    },
    '& textarea': {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.5,
      color: CALLOUT_FOREGROUND,
    },
  },
  policyFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1),
  },
  policyCount: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    lineHeight: 1.5,
    textTransform: 'uppercase',
    color: '#6B7C87',
    margin: 0,
    whiteSpace: 'nowrap',
  },
}))

export default useStyles
